
      if (import.meta.env.PROD) {
        const adsScript = document.createElement("script");
        adsScript.async = true;
        adsScript.src =
          "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        document.head.appendChild(adsScript);

        adsScript.onload = () => {
          const adsConfigScript = document.createElement("script");
          adsConfigScript.src = "/js/ads.js";
          document.head.appendChild(adsConfigScript);
        };
      } else {
        const adsStubScript = document.createElement("script");
        adsStubScript.src = "/js/ads-stub.js";
        document.head.appendChild(adsStubScript);
      }
    